<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        class="reservationModal"
        hide-footer
        scrollable
        header-class="p-0 border-0"
        @hidden="close">
        <template #modal-header="{ close }">
            <div style="width:100%;">
                <div class="customModalHeader d-flex align-items-center">
                    <h5 class="modal-title">メニュー詳細・予約日時の選択</h5>
                    <button type="button" aria-label="Close" class="close" @click="close">×</button>
                </div>
                <div class="customModalHeaderInfo d-block d-md-flex justify-content-center align-items-center">
                    <div class="d-block d-md-flex justify-content-center align-items-center">
                        <span>{{ $locale.consultation_host }}科:</span>
                        <span>{{ $store.state.reservation.medicalCourse.name }}</span>
                    </div>
                    <div
                        v-if="$store.state.configs.timezone == 1"
                        class="d-block d-md-flex justify-content-center align-items-center">
                        <span>&nbsp;&nbsp;タイムゾーン:</span>
                        <span>{{ $store.state.reservation.timezoneWithCurrentTime }}</span>
                    </div>
                </div>
            </div>
        </template>

        <div class="modalContent">
            <template v-if="doctorMenu !== null">
                <section class="modalSection">
                    <doctor-info
                        :doctor="doctorMenu.doctor"
                        :user="$store.state.reservation.user"
                        :early-schedule="doctorMenu.early_schedule"
                        with-extender
                        doctor-introduction-type="all"
                        align-doctor-image="center">
                    </doctor-info>
                </section>
                <hr class="divide">
                <section class="modalSection modalSectionPaddingTop">
                    <doctor-menu-base-info
                        :menu="doctorMenu"
                        :user="user"
                        :user-coupons="filteredUserCoupons"
                        with-extender
                        with-description>
                    </doctor-menu-base-info>
                </section>
            </template>

            <div v-if="mode === 'default' || mode === 'matching'">
                <hr class="divide">
                <section class="modalSection modalSectionPaddingTop">
                    <h3 class="modalHeading">予約日時の選択</h3>
                    <reservation-calendar/>
                </section>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import { mapMutations } from 'vuex'
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'
    import moment from 'moment-timezone'

    export default {
        data: function() {
            return {
                helper: YokumiruHelper,
                mode: 'default',
                modalShow: false,
                inProgress: false,
                user: null,
                doctorMenu: null,
                isShowDoctorIntroduction: false,
                isShowDoctorMenuDescription: false,
                errors: {},
                prevConsultation: null,
            }
        },

        computed: {
            /**
             * 所持クーポンのフィルタリング
             * （相談予約カテゴリのクーポンだけにする）
             *
             * @return {array}
             */
            filteredUserCoupons: function () {
                return this.helper.filteredUserCoupons(this.user)
            },
        },

        created: function() {
            moment.locale('ja')
            bus.$on('open-modal-reservation-doctor-menu-detail', this.open)
            bus.$on('close-modal-reservation-doctor-menu-detail', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-reservation-doctor-menu-detail')
            bus.$off('close-modal-reservation-doctor-menu-detail')
        },

        methods: {
            ...mapMutations({
                setSchedule: 'reservation/setSchedule',
            }),

            /**
             * モーダル表示
             */
            open: function() {
                this.setSchedule(null)
                this.mode = this.$store.state.reservation.mode
                this.doctorMenu = this.$store.state.reservation.doctorMenu
                this.user = this.$store.state.reservation.user
                this.isShowDoctorIntroduction = false
                this.isShowDoctorMenuDescription = false
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.setSchedule(null)
                this.modalShow = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.customModalHeader {
    padding:1rem;
    border-bottom:1px solid #dee2e6;
}

.customModalHeaderInfo {
    height: 50px;
    line-height: 50px;
    color: #757C83;
    font-size: 14px;
    text-align: center;
    background-color: #F8F8F8;
    border-bottom: 1px solid #dee2e6;

    @media screen and (max-width: 767px) {
        height: auto;
        line-height: 1.4;
        padding: 5px 0;
        font-size: 12px;
    }

    span {
        &:nth-child(2),
        &:nth-child(4) {
            color: #497EAF;
            font-size: 16px;
            font-weight: bold;

            @media screen and (max-width: 767px) {
                font-size: 14px;
            }
        }
    }
}

.modalContent {
    padding: 5px 14px;
}

.modalSection {
    position: relative;
}

.modalSectionPaddingTop {
    margin-top: 40px;
}

.modalSectionPaddingBottom {
    margin-bottom: 40px;
}

.modalHeading {
    margin-bottom: 15px;
    color: #7D868D;
    font-size: 16px;
    font-weight: bold;
}

.divide {
    border-top: 1px dotted #ABB3BA;
}

.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}
</style>
